export const NOT_SUPPORTED_IN_STUDIO_TAG_ID =
  'a29df144-9794-44cf-8ca4-3fd393fe6281';
export const NOT_SUPPORTED_IN_EDITOR_X_TAG_ID =
  'b789d0ab-b50e-4ce3-9d27-cf420cf42182';
